import { render } from "./WhatsappIntegration.vue?vue&type=template&id=c3e095f4&scoped=true&ts=true"
import script from "./WhatsappIntegration.vue?vue&type=script&lang=ts"
export * from "./WhatsappIntegration.vue?vue&type=script&lang=ts"

import "./WhatsappIntegration.vue?vue&type=style&index=0&id=c3e095f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e095f4"]])

export default __exports__